import React, { memo } from 'react'
import { Handle } from '@xyflow/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCircleMinus,
    faPenToSquare,
    faSquarePlus,
    faTrash,
    faUserPlus,
} from '@fortawesome/free-solid-svg-icons'

const PositionNode = ({ data }) => {
    const {
        label,
        onClickIconPosition,
        onClickEditPosition,
        onClickDeletePosition,
    } = data
    return (
        <div className="positionNode  !shadow-2xl">
            <div className="positionNode-label">{label}</div>

            <div className="departmentNode-box-icons flex gap-2">
                <span
                    onClick={onClickIconPosition}
                    className="departmentNode-department text-white"
                >
                    <FontAwesomeIcon icon={faSquarePlus} />
                </span>

                <span
                    className="departmentNode-trash text-red-600"
                    onClick={onClickDeletePosition}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </span>
                <span
                    className="departmentNode-trash !text-blue-600"
                    onClick={onClickEditPosition}
                >
                    <FontAwesomeIcon icon={faPenToSquare} />
                </span>
            </div>

            <Handle type="source" position="bottom" />
            <Handle type="target" position="top" />
        </div>
    )
}

export default memo(PositionNode)
